// extracted by mini-css-extract-plugin
module.exports = {"content":"AppLayout_content__3pVn1","container":"AppLayout_container__34gEx"};